import { Check, ArrowUpRight } from 'lucide-react';
import { Link } from 'react-router-dom';
import { Reveal, PageHero, Eyebrow, CTABand, SectionHeading } from '../components/Shared';
import { ServiceCapabilities } from '../components/ServiceCapabilities';
import { services, segments } from '../data/content';
import { company } from '../data/content';
import { useSeo } from '../hooks/useSeo';
import { L } from '../i18n/LocaleProvider';

const ServicePanel = ({ service }) => {
  const { id, name, tagline, description, bullets, icon: Icon, outcome } = service;
  return <Reveal className="service-detail glass" id={id} data-testid={`service-panel-${id}`}>
    <div className="service-detail-info">
      <div className="service-detail-eyebrow"><span className="service-icon"><Icon size={28} strokeWidth={1.3} /></span><Eyebrow id={`service-eyebrow-${id}`}>{name}</Eyebrow></div>
      <h2 data-testid={`service-heading-${id}`}>{tagline}</h2>
      <p data-testid={`service-description-${id}`}>{description}</p>
      <Link className="text-link" to={`/contact?service=${id}`} data-testid={`service-contact-${id}`}>Discuss this service <ArrowUpRight size={17} /></Link>
    </div>
    <div className="service-detail-list">
      <span className="small-label" data-testid={`service-list-heading-${id}`}>WHAT WE BRING TO THE TABLE</span>
      <ul>{bullets.map((bullet, i) => <li key={bullet} data-testid={`service-${id}-item-${i}`}><Check size={17} strokeWidth={1.5} />{bullet}</li>)}</ul>
      <span className="service-outcome" data-testid={`service-outcome-${id}`}><span className="pulse-dot" />{outcome}</span>
    </div>
    <ServiceCapabilities service={service} />
  </Reveal>;
};

export default function Services() {
  useSeo({ title: 'Services — AI Automation & Digital Transformation | TechSpitze', description: company.metaServices, image: '/brand/techspitze-logo.webp' });
  return <L><main id="main-content" data-testid="services-page">
    <PageHero eyebrow="OUR EXPERTISE" id="services-hero" lines={[{ text: 'Enterprise services.' }, { text: 'Built around outcomes.', accent: true }]} description="AI automation, digital transformation and enterprise technology — strategy, delivery and support around your business.">
      <Reveal delay={.4} className="service-jump-links">{services.map(service => <Link to={`#${service.id}`} key={service.id} data-testid={`jump-${service.id}`}><span>{service.number}</span>{service.name}<ArrowUpRight size={14} /></Link>)}</Reveal>
    </PageHero>
    <section className="container services-details" aria-label="Our four service pillars">{services.map(service => <ServicePanel service={service} key={service.id} />)}</section>
    <section className="container section engagement-section">
      <SectionHeading id="engagement-models" eyebrow="ENGAGEMENT MODELS" title="Your business. Your terms." />
      <div className="engagement-grid">{segments.map(({ name, icon: Icon, description }, i) => <Reveal className="engagement-card glass" key={name} delay={i * .06} data-testid={`engagement-model-${i}`}><Icon size={25} strokeWidth={1.3} /><h3>{name}</h3><p>{description}</p></Reveal>)}</div>
    </section>
    <CTABand id="services-cta" title={<>Let’s discuss<br />what’s next.</>} />
  </main></L>;
}